// theme.ts
import { DefaultTheme } from 'styled-components'
export const lightTheme: DefaultTheme = {
    colors: {
        primary: "#fff",
        secondary: "#F3F6F9",
    },
    textColor:{
        primary: "#000",

    },
    common: {
        black: '#000000',
        white: '#ffffff'
    },
}


export const darkTheme: DefaultTheme = {
    colors: {
        primary: "#0a1929",
        secondary: "rgb(0, 30, 60)",
    },
    textColor:{
        primary: "#fff",

    },
    common: {
        black: '#000000',
        white: '#ffffff'
    },
}